import { gql } from '@apollo/client';

/** Public SAML config returned by getPublicSamlCfgByAccountId */
export interface PublicSamlCfg {
  enabled: boolean;
  enablePasswordLogin: boolean;
  entryPoint: string | null;
  providerId: string | null;
  signInButtonLabel: string;
}

/** Result type for GET_PUBLIC_SAML_CFG query */
export interface GetPublicSamlCfgResult {
  getPublicSamlCfgByAccountId: PublicSamlCfg | null;
}

/** Variables type for GET_PUBLIC_SAML_CFG query */
export interface GetPublicSamlCfgVariables {
  accountId: string;
}

/**
 * Get public SAML config by accountId (no auth required).
 * Used by LoginPage to show/hide SAML button.
 * Returns { enabled, enablePasswordLogin, entryPoint, providerId, signInButtonLabel }.
 */
export const GET_PUBLIC_SAML_CFG = gql`
  query GetPublicSamlCfgByAccountId($accountId: String!) {
    getPublicSamlCfgByAccountId(accountId: $accountId)
  }
`;

/** Shape returned by findSSOLoginByHost — backend returns untyped JSON, we type the fields we use */
export interface SsoLoginByHostResponse {
  providerId?: string;
  entryPoint?: string;
  samlSSOUrl?: string;
}

/** Result type for FIND_SSO_LOGIN_BY_HOST query */
export interface FindSsoLoginByHostResult {
  findSSOLoginByHost: SsoLoginByHostResponse | null;
}

/** Variables type for FIND_SSO_LOGIN_BY_HOST query */
export interface FindSsoLoginByHostVariables {
  host: string;
}

/**
 * Detect SSO provider by hostname (no auth required).
 * Used by SamlLoginPage no-token fallback (mainly Flutter mobile app).
 */
export const FIND_SSO_LOGIN_BY_HOST = gql`
  query FindSSOLoginByHost($host: String!) {
    findSSOLoginByHost(host: $host)
  }
`;

/** Result type for CREATE_FIREBASE_CUSTOM_TOKEN mutation */
export interface CreateFirebaseCustomTokenResult {
  createFirebaseCustomToken: string | null;
}

/** Variables type for CREATE_FIREBASE_CUSTOM_TOKEN mutation */
export interface CreateFirebaseCustomTokenVariables {
  serviceName: string;
}

/**
 * Create an encrypted Firebase custom token for the authenticated user.
 * Used by SamlAppLoginPage to deliver token to Flutter mobile app.
 * Requires authentication — user must be signed in via Firebase first.
 * Backend encrypts the token with AES-CBC before returning.
 */
export const CREATE_FIREBASE_CUSTOM_TOKEN = gql`
  mutation CreateFirebaseCustomToken($serviceName: String!) {
    createFirebaseCustomToken(serviceName: $serviceName)
  }
`;
